import { css } from 'lit'

export default css`
    @keyframes delay-overflow {
        100% {
            overflow: auto;
        }
    }
    .container {
        position: relative;
        font-weight: var(--font-weight-medium);
        color: var(--grey1);
    }

    .options {
        position: absolute;
        border-radius: 4px;
        z-index: 3;
        width: calc(100% - 2px);
        margin-top: 8px;
        max-height: 0;
        border-color: rgba(152, 168, 183, 0); /* grey4 but using rgba so we can transition it */
        border-style: solid;
        border-width: 1px;
        transition:
            max-height 0.2s ease-in-out,
            border-color 0.2s ease-in-out;
        overflow-y: hidden;
        -webkit-overflow-scrolling: touch;
        outline: none;
    }

    .options.is-open {
        max-height: 140px;
        animation: 1s delay-overflow;
        animation-fill-mode: forwards;
        border-color: var(--grey4);
    }

    .option {
        padding: 10px 20px;
        cursor: pointer;
        background-color: white;
    }

    .is-placeholder {
        color: var(--grey3);
    }

    .option:hover,
    .option.is-selected {
        background-color: var(--grey8);
    }
`
